import {
  get,
  post,
  del,
  put
  //postWithMixFormData
  // postWithFormData
} from '../configApi'
export async function getUserRequestBySearch(data, search = null) {
  return await get(`/mylib/list/request/course`, {
    idcourse: data.idcourse,
    idroom: data.idroom,
    page: data.page,
    limit: data.limit,
    search: search
  })
}

export async function getUserAccept(data, search = null) {
  return await get(`/mylib/list/accept/course`, {
    idcourse: data.idcourse,
    idroom: data.idroom,
    page: data.page,
    limit: data.limit,
    search: search
  })
}

export async function acceptToCourse(body) {
  return await post(`/mylib/manage/accept`, body)
}

export async function rejectUserInCourse(body) {
  return await post(`/mylib/manage/reject`, body)
}

export async function editDateExp(body) {
  return await put(`/mylib/manage/editdate`, body)
}

export async function removeUserInCourse(body) {
  return await del(`/mylib/manage/remove`, body)
}

export async function removeUserInCourseAll(body) {
  return await post(`/mylib/manage/removeall`, body)
}

export async function listUserInCourseAll(body) {
  return await get(`/account/list/studentforremovelib`, body)
}

export async function removeUserInCourseAllWithLimit(body) {
  return await post(`/mylib/manage/removeallgroup`, body)
}


export async function uploadUserInCourse(body) {
  // let data = new FormData();
  //data.append('idcourse', body.idcourse)
  //data.append('excel', body.excel)

  return await post(`/mylib/add/excel`, body)
}
export async function uploadUserToPreview(body) {
  // let data = new FormData();
  //data.append('idcourse', body.idcourse)
  //data.append('excel', body.excel)

  return await post(`/mylib/add/import/preview`, body)
}
export async function insertStudentToCourse(body) {
  return await post(`/mylib/add/import/save`, body)
}

export async function getUserBySearch(body) {
  return await get(`/account/company/student`, body)
}
export async function getUserAll(params) {
  return await get(`/account/list/student`, params)
}
export async function addUserInCourseBySearch(body) {
  return await post(`/mylib/add/admin`, body)
}

// import user from group //
export async function getCourseListAll() {
  return await get(`/room/list/all`)
}
export async function getRoomStudentList(body) {
  return await get(`/room/list/student`, body)
}
export async function getRoomStudentMylib(body) {
  return await get(`/room/list/mylib`, body)
}
export async function addStudentFromGroup(body) {
  return await post(`/mylib/manage/addallgroup `, body)
}

